import React, { useEffect, useState } from "react";
import { getAdminRequests, approveRequest, rejectRequest } from "../../api";
import { useNavigate } from "react-router-dom";
import "./AdminApproval.css";

const AdminApproval = () => {
  const [requests, setRequests] = useState([]);
  const [role, setRole] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        const role = localStorage.getItem("adminRole");
        setRole(role);
        const response = await getAdminRequests(token);
        setRequests(response.data);
      } catch (error) {
        console.error("Error fetching requests:", error);
      }
    };
    fetchRequests();
  }, []);

  const handleApprove = async (adminId) => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await approveRequest(adminId, token);

      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.user_id === adminId
            ? { ...request, action: "approved" }
            : request
        )
      );
    } catch (error) {
      console.error("Error approving request:", error);
    }
  };

  const handleReject = async (adminId) => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await rejectRequest(adminId, token);

      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.user_id === adminId
            ? { ...request, action: "rejected" }
            : request
        )
      );
    } catch (error) {
      console.error("Error rejecting request:", error);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="dashboard-container">
      <h2>Pending Admin Approvals</h2>
      {requests.length === 0 ? (
        <div className="no-approvals-container">
          <p className="no-approvals">No pending Requests 😊</p>
        </div>
      ) : (
        <table className="requests-table">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Requested Role</th>
              <th>Status</th>
              <th>Approve</th>
              <th>Reject</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.user_id}>
                <td>{request.first_name}</td>
                <td>{request.last_name}</td>
                <td>{request.email}</td>
                <td>{request.requested_role}</td>
                <td>{request.action || "Pending"}</td>
                <td>
                  {request.action === "pending" && (
                    <button
                      className="approve-button"
                      onClick={() => handleApprove(request.user_id)}
                    >
                      Approve
                    </button>
                  )}
                </td>
                <td>
                  {request.action === "pending" && (
                    <button
                      className="reject-button"
                      onClick={() => handleReject(request.user_id)}
                    >
                      Reject
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <button className="back-button" onClick={handleBack}>
        &larr; Back
      </button>
    </div>
  );
};

export default AdminApproval;
